import { render, staticRenderFns } from "./DeliverableProjects.vue?vue&type=template&id=3186a0bc&"
import script from "./DeliverableProjects.vue?vue&type=script&lang=js&"
export * from "./DeliverableProjects.vue?vue&type=script&lang=js&"
import style0 from "./DeliverableProjects.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3186a0bc')) {
      api.createRecord('3186a0bc', component.options)
    } else {
      api.reload('3186a0bc', component.options)
    }
    module.hot.accept("./DeliverableProjects.vue?vue&type=template&id=3186a0bc&", function () {
      api.rerender('3186a0bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/DeliverableProjects.vue"
export default component.exports